import { HelpCircle, PlayCircle, Lightbulb, BookOpen } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { useTour } from "./tour-provider";

export function HelpMenu() {
  const { startTour, openPageHelp } = useTour();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          aria-label="Help menu"
          className="gap-2"
          data-testid="header-help-menu"
        >
          <HelpCircle className="h-4 w-4" />
          <span className="hidden sm:inline">Help</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>Need a hand?</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onSelect={() => startTour(0)}
          data-testid="help-menu-replay-tour"
        >
          <PlayCircle className="mr-2 h-4 w-4" />
          Replay the guided tour
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={() => openPageHelp()}
          data-testid="help-menu-page-help"
        >
          <Lightbulb className="mr-2 h-4 w-4" />
          What's on this page?
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild data-testid="help-menu-docs">
          <a
            href="https://sam.gov/help"
            target="_blank"
            rel="noopener noreferrer"
          >
            <BookOpen className="mr-2 h-4 w-4" />
            SAM.gov help center
          </a>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
